import type { FetchContext } from 'ofetch';
import type { ILaunchV3Response } from '~/interfaces/dto/games/response';
import { useGameStore } from '~/stores/games.store';

export const useLaunchService = () => {
  const { $fetch } = useNuxtApp();
  const launchGame = async ({ request }) => {
    return await $fetch<ILaunchV3Response>('api/v3/Gaming/launch', {
      base: 'base',
      method: 'post',
      body: request,
      useAuthentication: true,
      useEnvironment: true,
      onResponse(context: FetchContext & { response }): Promise<void> | void {
        if (!!context.response._data?.clientScriptData) {
          const csd = JSON.parse(context.response._data?.clientScriptData);
          context.response._data = {
            ...context.response._data,
            clientScriptData: JSON.stringify(csd || {}),
          };
          if (!!context.response._data?.fixedJackpotEventId) {
            const gameStore = useGameStore();
            gameStore.setInGameFixedJackpotEventId(
              context.response._data.fixedJackpotEventId,
            );
          }
        }
      },
    });
  };
  const launchLuckynumbers = async ({ request }) => {
    return await $fetch<ILaunchV3Response>(
      'api/v3/Gaming/launch/luckynumbers',
      {
        base: 'base',
        method: 'post',
        body: request,
        useAuthentication: true,
        useEnvironment: true,
        onResponse(context: FetchContext & { response }): Promise<void> | void {
          if (!!context.response._data?.clientScriptData) {
            const csd = JSON.parse(context.response._data?.clientScriptData);
            context.response._data = {
              ...context.response._data,
              clientScriptData: JSON.stringify(csd || {}),
            };
          }
        },
      },
    );
  };
  const launchFreeGame = async ({ request }) => {
    return await $fetch<ILaunchV3Response>('api/v3/Gaming/launch/demo', {
      base: 'base',
      method: 'post',
      body: request,
      useEnvironment: true,
      onResponse(context: FetchContext & { response }): Promise<void> | void {
        if (!!context.response._data?.clientScriptData) {
          const csd = JSON.parse(context.response._data?.clientScriptData);
          context.response._data = {
            ...context.response._data,
            clientScriptData: JSON.stringify(csd || {}),
          };
        }
      },
    });
  };
  return { launchGame, launchLuckynumbers, launchFreeGame };
};
